import { SHOW_STOP_CARDS, HIDE_STOP_CARDS, LOWER_STOP_CARDS, PEEK_STOP_CARDS } from '../actions/stopCardsActions'
import { Map } from 'immutable'
import StopCardStates from '../constants/StopCardStates'

const INITIAL_STATE = Map({ state: 'lower' })

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SHOW_STOP_CARDS:
            return state.set('state', StopCardStates.SHOW)
        case PEEK_STOP_CARDS:
            return state.set('state', StopCardStates.PEEK)
        case LOWER_STOP_CARDS:
            return state.set('state', StopCardStates.LOWER)
        case HIDE_STOP_CARDS:
            return state.set('state', StopCardStates.HIDE)
        default:
            return state
    }
}
